
//Types should be in const to avoid typos and duplication since it's a string and could be easily miss spelled
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const SUB_QUANTITY = 'SUB_QUANTITY';
export const ADD_QUANTITY = 'ADD_QUANTITY';
export const DISCOUNT = 'DISCOUNT';
export const TIP = 'TIP';
export const SPECIAL_REQUEST='SPECIAL_REQUEST';
export const REMOVE_DISCOUNT='REMOVE_DISCOUNT';
export const ADD_SHIPPING = 'ADD_SHIPPING';
export const SHOW_CART = 'SHOW_CART';
export const CLEAR_CART = 'CLEAR_CART';
export const ADD_SOLD_QUANTITY = 'ADD_SOLD_QUANTITY';
export const UPDATE_ITEM_SPECIAL_REQUEST = 'UPDATE_ITEM_SPECIAL_REQUEST';
